import React from 'react';

import { SVGPropsType } from 'src/types';

const Email = (props: SVGPropsType) => {
    const { fill, stroke, onClick, style, className } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            onClick={onClick}
            style={style}
            className={className}
        >
            <g clipPath="url(#clip0_33922_19692)">
                <circle cx="16" cy="16" r="16" fill={fill} />
                <path
                    d="M22.6818 9H10.3182C9.00455 9 8 10.0111 8 11.3333V20.6667C8 21.9889 9.00455 23 10.3182 23H22.6818C23.9955 23 25 21.9889 25 20.6667V11.3333C25 10.0111 23.9955 9 22.6818 9ZM10.3182 10.5556H22.6818C22.9909 10.5556 23.2227 10.7111 23.3773 11.0222L16.5 15.8444L9.62273 11.0222C9.77727 10.7111 10.0091 10.5556 10.3182 10.5556ZM22.6818 21.4444H10.3182C9.85455 21.4444 9.54545 21.1333 9.54545 20.6667V12.8111L16.0364 17.4C16.1909 17.4778 16.3455 17.5556 16.5 17.5556C16.6545 17.5556 16.8091 17.4778 16.9636 17.4L23.4545 12.8111V20.6667C23.4545 21.1333 23.1455 21.4444 22.6818 21.4444Z"
                    fill={stroke}
                />
            </g>
            <defs>
                <clipPath id="clip0_33922_19692">
                    <rect width="32" height="32" fill={stroke} />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Email;
